import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import DetailPage from "@/pages/detail/page";
import NewsPage from "@/pages/news/page";
import NewsDetailPage from "@/pages/news/detail/page";
import SearchPage from "@/pages/search/page";
import AboutPage from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "category",
        element: <CategoryPage />,
      },
      {
        path: "detail/:id",
        element: <DetailPage />,
      },
      {
        path: "news",
        element: <NewsPage />,
      },
      {
        path: "news/:id",
        element: <NewsDetailPage />,
      },
      {
        path: "search",
        element: <SearchPage />,
      },
      {
        path: "about",
        element: <AboutPage />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;